export default {
	organisation: "",
	firstName: "",
	lastName: "",
	phone: "",
	emailAddress: "",
	country: "NZ",
	password: "",
	registerErrorMessage: "",
	isValid: false,
};
